import { Button } from '../../../../../Button/Button';
import Modal from '../../../../../Modal';

type CloseGameModalProps = {
  show: boolean;
  close: () => void;
  onConfirm: () => void;
  onReject: () => void;
};

function CloseGameModal({
  show,
  close,
  onConfirm,
  onReject,
}: CloseGameModalProps) {
  return (
    <Modal show={show} close={close}>
      <h2 className="mb-3">Spiel verlassen?</h2>
      <p className="mb-6">
        Du bist der einzige verbleibende Spieler in dem aktuellen Spiel. Wenn du
        das Spiel verlässt, wird es geschlossen.
      </p>
      <div className="flex flex-row gap-2 justify-center items-center">
        <Button className="w-20" variant="secondary" onClick={onConfirm}>
          Ja
        </Button>
        <Button className="w-20" onClick={onReject}>
          Nein
        </Button>
      </div>
    </Modal>
  );
}

export default CloseGameModal;
